import styled from 'styled-components';
import { mq } from '@phishtool/ui';
export const ContentBox = styled.div.withConfig({ displayName: "ContentBox", componentId: "-18n2ou3" }) `
  background-color: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.silverPearl};
  border-radius: ${(props) => props.theme.borderRadius.primary};

  ${(props) => mq({
    padding: [props.theme.spacers.large, props.theme.spacers.xxl],
})}
`;
export const ContentWrapperInner = styled.div.withConfig({ displayName: "ContentWrapperInner", componentId: "-yc3m21" }) `
  position: relative;
`;
export default styled.div.withConfig({ componentId: "-1kv1sht" }) `
  position: relative;
  overflow: hidden;
  flex: 1;

  ${(props) => mq({
    padding: [`${props.theme.spacers.xxl} 0`, null, `${props.theme.spacers.massive} 0`],
})}
`;
